// eslint-disable-next-line import/prefer-default-export
var breakpoint = {
  /** Deprecated breakpoint */
  palm: 'screen and (max-width: 44.9375em)',
  /** Deprecated breakpoint */
  lap: 'screen and (min-width: 45em) and (max-width: 63.9375em)',
  /** Deprecated breakpoint */
  lapAndUp: 'screen and (min-width: 45em)',
  /** Deprecated breakpoint */
  portable: 'screen and (max-width: 63.9375em)',
  /** Deprecated breakpoint */
  desk: 'screen and (min-width: 64em)'
};

export { breakpoint };
